import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ButtonTypeEnum} from '@shared/button/button.directive';
import {SafeResourceUrl} from '@angular/platform-browser';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';

@Component({
    selector: 'app-i-frame-modal',
    templateUrl: 'i-frame-modal.component.html',
    styleUrls: ['./i-frame-modal.component.scss'],
})
export class IFrameModalComponent implements OnInit{
    readonly buttonType = ButtonTypeEnum;

    url?: SafeResourceUrl;

    isMobile: boolean = false;

    constructor(
        private dialogRef: MatDialogRef<IFrameModalComponent>,
        breakpointObserver: BreakpointObserver,
        @Inject(MAT_DIALOG_DATA) public data: {url: string},
    ) {
        this.isMobile = breakpointObserver.isMatched(Breakpoints.XSmall);
    }

    ngOnInit() {
        this.url = this.data ? this.data.url : '';
    }

    onCancel(): void {
        this.dialogRef.close();
    }
}
